import api from "./axios";

const MAX_LENGTH = 4000;

const trim = (value, max = MAX_LENGTH) =>
    value == null ? "" : String(value).slice(0, max);

export const reportClientError = (error, type = "JAVASCRIPT_ERROR", extra = {}) => {
    // 4xx는 로그인 실패, 입력값 오류, 권한 부족 등 사용자가 해결할 수 있는 업무 오류입니다.
    // 서버 장애(5xx)와 응답 자체가 없는 네트워크/코드 오류만 개발 오류로 수집합니다.
    const status = error?.response?.status;
    if (status && status >= 400 && status < 500) {
        return;
    }

    const normalized = error instanceof Error ? error : new Error(String(error));

    // 오류 보고 자체가 앱 오류를 연쇄적으로 일으키지 않도록 fire-and-forget 처리합니다.
    api.post("/client-errors", {
        type: trim(status >= 500 ? "SERVER_ERROR" : type, 100),
        message: trim(normalized.message, 2000),
        stack: trim(normalized.stack),
        url: trim(window.location.href, 2000),
        userAgent: trim(window.navigator.userAgent, 100),
        ...extra,
    }).catch(() => {});
};

export const installGlobalErrorReporter = () => {
    const onError = (event) => {
        reportClientError(event.error || event.message, "WINDOW_ERROR");
    };
    const onUnhandledRejection = (event) => {
        reportClientError(event.reason, "UNHANDLED_REJECTION");
    };

    window.addEventListener("error", onError);
    window.addEventListener("unhandledrejection", onUnhandledRejection);

    return () => {
        window.removeEventListener("error", onError);
        window.removeEventListener("unhandledrejection", onUnhandledRejection);
    };
};
